// extracted by mini-css-extract-plugin
module.exports = {"aboutWrapper":"aboutProgram-module--aboutWrapper--2WfD6","aboutContent":"aboutProgram-module--aboutContent--1i08b","contentWrapper":"aboutProgram-module--contentWrapper--3vHfP"};